export default class PostsCarousel {
    constructor() {
        this.carouselEl = document.querySelector('.posts-carousel');
        if (!this.carouselEl || this.carouselEl.swiper || typeof window.Swiper === 'undefined') {
            return;
        }

        this.section = this.carouselEl.closest('.posts-section');
        this.wrapper = this.carouselEl.querySelector('.swiper-wrapper');
        this.panel = this.section.querySelector('#posts-panel');
        this.tablist = this.section.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.tablist.querySelectorAll('[data-posts-feed]'));
        this.heading = this.section.querySelector('[data-posts-heading]');
        this.cta = this.section.querySelector('[data-posts-cta]');
        this.empty = this.section.querySelector('[data-posts-empty]');
        this.pagination = this.section.querySelector('.posts-carousel-pagination');
        this.feeds = new Map(this.tabs.map((tab) => {
            const type = tab.dataset.postsFeed;
            const template = this.section.querySelector(`[data-posts-template="${type}"]`);
            const slides = Array.from(type === 'blog' ? this.wrapper.children : template.content.children);
            slides.forEach((slide, index) => {
                slide.setAttribute('role', 'group');
                slide.setAttribute('aria-label', `Objava ${index + 1} od ${slides.length}`);
            });
            return [type, {tab, slides, ...tab.dataset}];
        }));
        this.activeFeed = 'blog';
        this.init();
    }

    init() {
        this.swiper = new window.Swiper(this.carouselEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchSlidesProgress: true,
            lazyPreloadPrevNext: 1,
            pagination: {
                el: this.pagination,
                clickable: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                containerMessage: this.feeds.get('blog').label,
                slideRole: 'group',
                slideMessage: 'Objava {{index}} od {{slidesLength}}',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
            },
        });

        this.bindCardClicks();
        this.bindTabs();
        this.panel.setAttribute('role', 'tabpanel');
        this.panel.setAttribute('aria-labelledby', this.feeds.get('blog').tab.id);
        this.panel.tabIndex = 0;
        this.tablist.hidden = false;
        this.section.querySelector('[data-posts-fallback]').hidden = true;
    }

    setFeed(type) {
        if (type === this.activeFeed || !this.feeds.has(type)) return;

        const feed = this.feeds.get(type);
        this.activeFeed = type;
        this.tabs.forEach((tab) => {
            const selected = tab === feed.tab;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            tab.classList.toggle('is-active', selected);
        });
        this.panel.setAttribute('aria-labelledby', feed.tab.id);
        this.heading.textContent = feed.heading;
        this.cta.textContent = feed.cta;
        this.cta.href = feed.url;
        this.carouselEl.setAttribute('aria-label', feed.label);
        this.swiper.params.a11y.containerMessage = feed.label;
        this.empty.textContent = feed.empty;
        this.empty.hidden = feed.slides.length > 0;
        this.pagination.hidden = feed.slides.length === 0;
        this.wrapper.replaceChildren(...feed.slides);
        this.swiper.update();
        this.swiper.slideTo(0, 0, false);
    }

    bindTabs() {
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.setFeed(tab.dataset.postsFeed));
            tab.addEventListener('keydown', (event) => {
                let next;
                switch (event.key) {
                    case 'ArrowLeft': next = (index + this.tabs.length - 1) % this.tabs.length; break;
                    case 'ArrowRight': next = (index + 1) % this.tabs.length; break;
                    case 'Home': next = 0; break;
                    case 'End': next = this.tabs.length - 1; break;
                    default: return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.tabs[next].focus();
                this.setFeed(this.tabs[next].dataset.postsFeed);
            });
        });
    }

    bindCardClicks() {
        this.carouselEl.addEventListener('click', (event) => {
            if (!this.swiper.allowClick || event.defaultPrevented) return;
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            if (event.target.closest('a, button, input, select, textarea')) return;
            const article = event.target.closest('article');
            if (!article || !this.carouselEl.contains(article)) return;
            const link = article.querySelector('h3 a, a');
            if (link) link.click();
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new PostsCarousel();
    });
} else {
    new PostsCarousel();
}
